import { Author, AuthorRequest } from '@feature/utils';

export const publishedInList = ['PUBLISHER', 'JOURNAL'] as const;
export type PublishedIn = (typeof publishedInList)[number];

export const reachTypeList = ['NATIONAL', 'INTERNATIONAL'] as const;
export type ReachType = (typeof reachTypeList)[number];

export const journalReputationTypeList = ['WOS', 'BDI', 'THOMSON_REUTERS', 'OTHER'] as const;
export type JournalReputationType = (typeof journalReputationTypeList)[number];

export const publisherReputationTypeList = ['CONSECRETED', 'OTHER'] as const;
export type PublisherReputationType = (typeof publisherReputationTypeList)[number];

export interface EditorialTeam {
  id: number;

  title: string; // autogenerated on backend
  type: PublishedIn;
  publisherName: string;
  journalName: string;
  reachType: ReachType;
  journalReputation: JournalReputationType;
  publisherReputation: PublisherReputationType;
  startYear: number;
  endYear: number;

  authors: Author[];
}

export interface EditorialTeamRequest {
  type: PublishedIn;
  publisherName: string | null;
  journalName: string | null;
  reachType: ReachType;
  journalReputation: JournalReputationType | null;
  publisherReputation: PublisherReputationType | null;
  startYear: number;
  endYear: number | null;
  authors: AuthorRequest[];
}
